import camanage from "./camanage"
import certificate from "./certificate"
import blockchain from "./blockchain"
import drive from "./drive"
import system from "./system"
import configmanage from "./configmanage"
import excellent from "./excellent"
import expension from "./expension"
import datamigration from "./datamigration"
import crosschain from "./crosschain"
import oracle from "./oracle"
import contractdetector from "./contractdetector"
import node from "./node"

export default {
  camanage: camanage,
  certificate: certificate,
  blockchain: blockchain,
  drive: drive,
  system: system,
  configmanage: configmanage,
  excellent: excellent,
  expension: expension,
  datamigration: datamigration,
  crosschain: crosschain,
  oracle: oracle,
  contractdetector: contractdetector,
  node: node
}